module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Two")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_vm._v("Josey had been taken aback, instantly suspicious until he explained that he was on his way to see his grandmother, who was in her seventies.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“She has more money than she knows what to do with and lives on a huge ranch to the east of here,” Jack said. “You’d be doing me a huge favor, and I’d make it worth your while. The ranch is sixty miles from the nearest town and a good ten from the nearest neighbor.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("A remote ranch. Could she really get this lucky? He was offering her exactly what she needed, as if he knew how desperate she was. Was it that obvious?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“What do you get out of it?” she asked, wary.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Your company as well as a diversion. Since we’re on our honeymoon I have the perfect excuse to spend less time at my grandmother’s bedside.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I take it you aren’t close.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He laughed at that. “You have no idea.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Still, she made him work for it. This wasn’t her first rodeo, as they said out here in the West, and Jack Winchester was definitely not the first con man she’d come across in her twenty-eight years.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("He was good, though, smooth, sexy and charm")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("ing as the devil, with a grin that would have had her naked—had she still been young and naive.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She was neither. She’d learned the hard way about men like Jack Winchester back in her wild days.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("But she also knew he would be suspicious if she gave in right away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“One week,” she said, hoping she wasn’t making a huge mistake. Jack had showed up just when she needed him and this marriage charade. No wonder she was feeling this was too good to be true.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("But given her lack of options…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He flashed her a sexy grin, and she told herself all she had to do was resist his cowboy charm for a week. No problem.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She closed her eyes and dozed until she felt him slowing down on the outskirts of what appeared to be a small Western town nestled in a river bottom.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Welcome to Whitehorse,” Jack said with a laugh as they crossed a narrow bridge. “I thought we’d buy a few things for you to wear this week. I’m guessing you don’t have a lot of clothing in that backpack.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("That almost made her laugh as she pulled the backpack closer. “I definitely could use some clothes and a shower before I meet your grandmother.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“No problem. Just tell me what you need. I’m sure there’s a truck stop at one end of this town or another. It’s the only town for miles up here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She looked over at him. He was making this too easy. Was he thinking that with a wife his grandmother would give him twice the inheritance? “You’re sure about this? Because I’m really not dressed to go into a clothing store,” she said, sliding down in the seat as they entered town.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  })]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("J"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ACK FELT A CHILL")]), _vm._v(" as Josey turned up the collar on her jean jacket and slid down in her seat. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who the hell is after her? And what the hell have I got myself into?")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Still, the gambler in him told him to stick to his plan. He couldn’t throw this woman to the wolves. “My wife can have anything she wants or needs,” he said. “Just name it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("And she did, including hair dye and a pair of sharp scissors. He hadn’t even lifted a brow, but he’d hated the thought of what she planned to do to that beautiful hair of hers.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("It definitely brought home the realization that he’d underestimated just how much trouble this woman was in. “I’ll tell you what. Why don’t I drop you at the truck stop? You can get a hot shower, get out of those clothes and I’ll come by with everything else you need.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“You don’t know my size.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I’m good at guessing.” He saw her hesitate. “Trust me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Like a dog that’d been kicked too many times, her look said, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("When hell freezes over.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She told him what else she needed, which turned out to be just about everything. He had to wonder what "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" in that backpack. It looked full. But apparently there wasn’t much clothing in it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Whatever was in the backpack, it was something she wasn’t letting out of her sight. She kept the backpack close, taking it with her when he dropped her at the truck stop.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Jack watched her walk away, her head down as if trying to go unnoticed, and told himself he was going to regret this.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  })]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("J"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OSEY DIDN’T EXPECT")]), _vm._v(" to see Jack Winchester again as he drove away from the truck stop. She wouldn’t have blamed him. She’d caught the look that crossed his handsome face when she’d asked for the dark hair dye and scissors.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Only a fool wouldn’t get the implication of that and Jack, she suspected, was no fool. By the time she’d showered, she’d found the items she’d asked for waiting for her just outside the shower door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She took the scissors to her hair, surprised by how painful it was. It was just hair. It would grow back. But she knew she wasn’t upset about her hair. It was all the other losses in her life.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She let the dye set in her short hair as she avoided looking in the mirror, then took another shower, wondering if she would ever feel truly clean again. In the bags he’d left for her, she found jeans, shirts, a couple of summer dresses, sandals, undergarments, a robe and nightgown, and even a pair of cowboy boots.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Josey shook her head, amazed that he would make so many purchases including the two scarves she’d asked for. He really was good at guessing. He’d not only guessed her sizes right down to her shoe size, but he’d chosen colors and styles that she might have chosen for herself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She’d been so touched, it had choked her up, and she realized how long it had been since someone had been nice to her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("Jack was waiting for her in the shade outside beside the Cadillac. It surprised her that she’d been dreading his reaction to the change in her appearance. She’d worn the boots, jeans and Western shirt he’d bought her, as ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("well as a scarf tied around her neck that went with the shirt.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He smiled when he saw her. His gaze took in her hair first, then the rest of her. “I see the clothes fit.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Yes, thank you.” She felt strangely shy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I like your new look,” he said, nodding, as they climbed into the car.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“You do?” she asked, and braved checking herself in the vanity mirror. It startled her, seeing herself as a brunette with short curly hair that framed her face. Her green eyes appeared huge to her. Or maybe it was the dark shadows under them. She didn’t even recognize herself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“It suits you,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Thank you.” She snapped the visor up. Who was she kidding? Changing her hairstyle wasn’t going to save her. Nothing would. It was just a matter of time before the rest of her world came crashing down.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She saw Jack looking at her backpack again, even more curious. She’d put her dirty clothing and sneakers into one of the shopping bags, and had to stuff the second bag with the new clothing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She’d have to watch him closely until she had an opportunity to hide the backpack’s contents for safekeeping during the week at the ranch.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("If she lasted the week. If there was even a ranch, she thought, as Jack drove south on a highway even less traveled than the last one they’d been on.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She no longer trusted herself to separate the good guys from the bad.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  })]), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("J"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ACK STUDIED")]), _vm._v(" J"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OSEY")]), _vm._v(" as they left town. The new hairstyle and color only made her more striking. A woman ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("like her couldn’t go unnoticed, if that was what she was hoping. So far, he thought she was safe. The truck stop hadn’t been busy, and the clerk there hadn’t given either of them a second glance. She’d been too busy watching the small television behind the counter.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Jack had noticed that when Josey came out to the car she’d carried both bags of clothing he’d purchased for her as well as that backpack she refused to let out of her sight. With her dirty clothes in one bag and the other bag overstuffed with her new clothes, he was even more concerned about what was in her backpack.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“You didn’t have to buy me so much,” Josey said now as he drove east out of town.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I wouldn’t want my grandmother to think that I’m cheap when it comes to my wife and her wardrobe.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("His expression sobered at the thought of his grandmother, Pepper Winchester. He didn’t give a damn what she thought, but he "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("did")]), _vm._v(" want her to believe this marriage was real. It hadn’t crossed his mind to bring a “wife” along. Not until he’d picked up Josey beside the road and had this overwhelming desire to help her. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("No good deed goes unpunished,")]), _vm._v(" he could hear his father say.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Jack admitted that his motives hadn’t been completely selfless. Having a wife would allow him more freedom on the ranch, freedom he would need.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He thought of his mother and told himself he was doing this for her. It wasn’t about revenge. It was about justice.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("As he glanced over at Josey, he knew he would have to be careful, though. Josey was a beautiful woman. He couldn’t afford to get involved in her trouble and lose sight of why he was really going to the ranch.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("He reminded himself Josey had gone along with the ")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("“marriage” because she needed to hide out somewhere safe for a week—just as he’d suspected. What was there to worry about?")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I hope we’ve got everything we need,” he said, glancing back at Whitehorse in his rearview mirror. The tiny Western town was only about ten blocks square with more churches than bars, one of the many small towns that had spouted up beside the tracks when the railroad had come through.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“A few more miles and it will be the end of civilization as we know it,” Jack said. “There are no convenience stores out here, nothing but rolling prairie as far as the eye can see.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“It sounds wonderful,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I should probably fill you in on my grandmother,” Jack said, as the road turned to gravel and angled to the southeast. “She’s been a recluse for the past twenty-seven years and now, according to her attorney, she wants to see her family. The letter I received made it sound as if she is dying.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Josey looked sympathetic. “I’m sorry. A recluse for twenty-seven years? I can understand why you might not have been close.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I was six the last time I saw her.” But he remembered her only too well. Her and the ranch and those long summer days with his mother, all of them living a lie.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  })]), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("S")]), _vm._v(" J"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ACK DROVE OUT")]), _vm._v(" of Whitehorse, Josey felt a little better. She’d been nervous in town, trying hard not to look over her shoulder the whole time. At the truck stop, she’d just about changed her mind. She desperately needed to put more distance between her and her past. But the only other option was hooking a ride with ")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("a trucker passing through, since there appeared to be no place in this town that she could rent a car or even buy one.")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Also, why chance it when she could hide out for a week at some remote ranch? She was anxious to do the one thing she needed to do, but it would have to wait just a little longer. She certainly couldn’t chance walking into a bank in this town. It was too risky.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("But then again, how risky was it pretending to be a stranger’s wife? Even as desperate as she was. Even as good-looking and normal as Jack Winchester appeared.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Who was this man? And what was the deal with his reclusive grandmother? She reminded herself how bad her judgment had been lately, her hand going to her neck beneath the scarf and making her wince with pain. She hoped she hadn’t just jumped from the frying pan into the fire.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("As the Cadillac roared down the fairly wide gravel road through rolling grasslands and rocky knolls, she tried to relax. But Jack Winchester had her confused. He seemed like a nice guy, but nice guys didn’t fool their grandmothers with fake wives.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Even though she’d fought it, Josey must have dozed off. She woke as the Cadillac hit a bump and sat up, surprised to see that the road they were on had narrowed to a dirt track. The land had changed, becoming more rough, more desolate.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("There were no buildings, nothing but wild country, and she had the feeling there hadn’t been for miles.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Is the ranch much farther?” she asked, afraid she’d been duped. Again.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("Sagebrush dotted the arid hills and gullies, and ")]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("stunted junipers grew along rocky breaks. Dust boiled up behind the Cadillac, the road ahead more of the same.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“It’s a bit farther,” Jack said. “The ranch isn’t far from a paved highway—as the crow flies. But the only way to get there is this road, I’m afraid.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Josey felt a prickle of fear skitter over her skin. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("But come on, what man would buy you clothes just to take you out in the middle of nowhere and kill you?")]), _vm._v(" She shuddered, thinking she knew a man exactly like that.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“You thought I was kidding about the Winchester Ranch being remote?” Jack asked with a laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("When he had told her about where they would be spending the week, she had thought it perfect. But now she doubted there was even a ranch at the end of this road. It wouldn’t be the first time she’d been played for a fool, but it could be the last. Josey had a bad feeling that she’d used up any luck she’d ever had a long time ago.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She shifted in her seat and drew the backpack closer, considering what she was going to do if this turned out to be another trap. Jack didn’t look like a deranged madman who was driving all this way to torture and kill her. But then RJ hadn’t looked like a deranged madman, either, had he?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She stared at the road ahead as Jack drove deeper into the wild, uninhabited country. Occasionally she would see a wheat field, but no sign of a house or another person.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("As the convertible came over a rise in the road, Jack touched his brakes, even though all she could see was more of the same wild landscape. He turned onto ")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("an even less used road, the land suddenly dropping precariously.")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Are you sure you’re on the right road?” Her hand went to her backpack, heart hammering in her chest as she eased open the drawstring and closed her hand around the gun handle, realizing she had only four shots left.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I’m beginning to wonder about that myself. I asked for directions back at a gas station in town before I picked you up, so I’m pretty sure I’m on the right road.” The car bumped down the uneven track, then turned sharply to the right. “There it is.” He sounded as relieved as she felt.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Josey looked up in surprise to see a cluster of log buildings at the base of the rugged hills behind it. A little farther down the road Jack turned under a huge weathered wooden arch, with the words "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Winchester Ranch")]), _vm._v(" carved in it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Her relief was almost palpable. Josey released her hold on the pistol, trying to still her thundering heart as the Cadillac bumped down the narrow dirt road toward the ranch buildings.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She frowned, noting suddenly how the grass had grown between the two tracks in the road, as if it hadn’t had much use. As they grew closer, she saw that the cluster of log buildings looked old and…deserted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Josey reminded herself that the grandmother had been a recluse for the past twenty-seven years. At least that was what Jack had said. So she probably hadn’t had a lot of company or use on the road.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("After what she’d been through, Josey thought she could handle anything. But she suddenly feared that wasn’t true. She didn’t feel strong enough yet to be tested ")]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("again. She wasn’t sure how much more she could take before she broke.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("As they rounded a bend in the road, her pulse quickened. This place was huge and creepy-looking. Sun glinted off a line of bleached white antlers piled in the middle of a rock garden. She noticed other heads of dead animals, the bones picked clean and hanging on the wood fence under a row of huge cottonwoods. As she looked at the house, she thought of the “big bad wolf” fairy tale and wondered if a kindly grandmother—or something a lot more dangerous—was waiting inside.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Jack parked in front and killed the engine. A breathless silence seemed to fill the air. Nothing moved. A horse whinnied from a log barn in the distance, startling Josey. Closer a bug buzzed, sounding like a rattlesnake. She felt jumpy and wondered if she’d lost her mind going along with this.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Are you all right?” he asked. He looked worried.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She nodded, realizing she was here now and had little choice but to go through with it. But this ranch certainly wasn’t what she’d expected. Not this huge, eerie-looking place, that was for sure.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I know it doesn’t look like much,” Jack said, as if reading her mind.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The house was a massive, sprawling log structure with wings running off from the main section and two stories on all but one wing that had an odd third story added toward the back. The place reminded her of a smaller version of Old Faithful Lodge in Yellowstone Park.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("At one time, the building must have been amazing. But it had seen better days and now just looked dark ")]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("and deserted, the grimy windows like blind eyes staring blankly out at them.")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Don’t look so scared,” Jack said under his breath. “My grandmother isn’t that bad. Really.” He made it sound like a joke, but his words only unnerved her further.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("As the front door opened, an elderly woman with long, plaited salt-and-pepper hair filled the doorway. Her braid hung over one shoulder of the black caftan she wore, her face in shadow.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Showtime,” Jack said as he put his arm around Josey and drew her close. She fit against him, and for a moment Josey could almost pretend this wasn’t a charade, she was so relieved that at least part of Jack’s story had been true. An old woman lived here. Was this the grandmother?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Jack planted a kiss in her hair and whispered, “We’re newlyweds, remember.” There was a teasing glint in his blue gaze as he dropped his mouth to hers.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The kiss was brief, but unnervingly powerful. As Jack pulled back he frowned. “I can see why we eloped so quickly after meeting each other,” he said, his voice rough with a desire that fired his gaze. This handsome man was much more dangerous than she’d thought. In at least one way, she had definitely jumped from the skillet into the fire.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She gave Jack a playful shove as if she’d just seen the woman in the doorway and was embarrassed, then checked to make sure the scarf around her neck was in place before opening her door and stepping out, taking the backpack with her. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Showtime,")]), _vm._v(" she thought, echoing Jack’s words.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("No one would ever find her here, wherever she was. ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("She had to pull this off. She was safe. That was all she had to think about right now, and as long as she was safe her mother would be, as well. One week. She could do this.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Jack was by her side in a flash, his arm around her, as they walked toward the house. An ugly old dog came out growling, but the elderly woman shooed him away with her cane.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Josey studied the woman in the doorway as she drew closer. Jack’s grandmother? She didn’t have his coloring. While he was blond and blue-eyed, she was dark from her hair to her eyes, a striking, statuesque woman with a face that could have been chiseled from marble, it was so cold.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Hello, Grandmother,” Jack said, giving the woman a kiss on her cheek. “This is my wife—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Josey Winchester,” Josey said, stepping forward and extending her hand. The woman took it with obvious surprise—and irritation. Her hand was ice-cold, and her vapid touch sent a chill through Josey.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I didn’t realize you were married, let alone that you’d be bringing a wife,” his grandmother said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Jack hadn’t planned on bringing a wife. So why had he? Josey wondered. It certainly hadn’t ingratiated his grandmother to him. And as for money…was there any? This place didn’t suggest it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“This is my grandmother, Pepper Winchester,” Jack said, an edge to his voice.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The elderly woman leaned on her cane, her gaze skimming over Josey before shifting back to Jack. “So, you’re my son Angus’s boy.” Wouldn’t she "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("know")]), _vm._v(" he was her son’s child? The woman must be senile, Josey thought. Or was there some reason to question his paternity?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I remember the day your mother showed up at the door with you,” Pepper said. “What were you then?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Two,” Jack said, clearly uncomfortable.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("His grandmother nodded. “Yes. I should have been suspicious when Angus involved himself in the hiring of the nanny,” Pepper said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("So Jack was the bastard grandson. That explained this less than warm reception.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Jack’s jaw muscle tensed, but his anger didn’t show in his handsome face. He put his arm around Josey’s waist and pulled her closer, as if he needed her as a buffer between him and his grandmother. Another reason he’d made her this phony marriage offer?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("When he’d told her about his grandmother and this visit, Josey had pictured an elderly woman lying in bed hooked up to machines, about to take her final gasp.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("This woman standing before them didn’t look anywhere near death’s door. Josey had speculated that this was about money. What else? But if she was right, then Jack had underestimated his grandmother. This woman looked like someone who planned to live forever and take whatever she had with her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Since I didn’t realize you had a wife,” Pepper Winchester was saying, “I’ll have to instruct my housekeeper to make up a different room for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Please don’t go to any trouble on my account,” Jack said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The grandmother smiled at this, cutting her dark gaze to him, eyes narrowing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Be careful,")]), _vm._v(" Josey thought. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("This woman is sharp.")])]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  })]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("J"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ACK HESITATED")]), _vm._v(" at the door to the huge ranch lodge. This place had once been filled with happy memories for him, because he’d lived here oblivious to what was really going on. Ignorance had been bliss. He’d played with the other grandchildren, ridden horses, felt like a Winchester even before his mother had confessed that he was one and he realized so much of their lives had been lies.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Coming, dear?” Josey called from the open front doorway.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He looked at his beautiful wife and was more than grateful she’d agreed to this. He wasn’t sure he could have done it alone. Josey, so far, was a godsend. His grandmother was a lot more on the ball than he’d thought she would be at this age.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Grandma had disappeared into the musty maze of the lodge, leaving them in the entryway. Jack was surprised that he still felt awe, just as he had the first time he’d seen it. This place had been built back in the nineteen forties and had the feel of another era in Western history.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He stared at the varnished log stairway that climbed to the upper floors, remembering all the times he’d seen his mother coming down those stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Mrs. Winchester said you are to wait down here.” Jack swung around, surprised to see the gnarled, petite elderly woman who had managed to sneak up on them. To his shock, he recognized her. “Enid?” She was still alive?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("If she recognized him, she gave no indication as she pointed down the hallway then left, saying she had to get their room ready. She left grumbling to herself.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("Behind them, the front door opened, and an elderly ")]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("man came in carrying Jack’s two pieces of luggage from the trunk of the Cadillac. Alfred, Enid’s husband. Amazing.")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He noticed that Josey still had her backpack slung over one shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Alfred noticed, as well. “I’ll take that,” the old man said, pointing to it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She shook her head, her hand tightening around the strap. “I’ll keep it with me, thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Alfred scowled at her before heading up the stairs, his footsteps labored under the weight of the bags and his disapproval.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I can’t believe those two are still alive,” Jack whispered to Josey, as he led her down the hallway. “I remember them both being old when I was a kid. I guess they weren’t that old, but they sure seemed it.” He wondered if his grandmother would be joining them and was relieved to find the parlor empty.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Josey took a seat, setting her backpack on the floor next to her, always within reach. Jack didn’t even want to speculate on what might be in it. He had a bad feeling it was something he’d be better off not knowing.")])])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page29"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-187059e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/hitched_ch02.vue
// module id = 81
// module chunks = 0